
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { css } from 'aphrodite';
import shortid from 'shortid';

import Filter from '../Filter';
import ExtraFiltersCollapse from '../FilterGroupCollection/Panels/PanelLarge/ExtraFiltersCollapse';
import CaretWrapper from './CaretWrapper';

import styles from './styles.js';

class PanelFilterGroupCollection extends Component {
    static propTypes = {
        activeFilterGroupCollectionIndex: PropTypes.number.isRequired,
        allDay: PropTypes.bool.isRequired,
        expandedGroups: PropTypes.array.isRequired,
        filterGroupCollection: PropTypes.object.isRequired,
        filterGroupCollectionIndex: PropTypes.number.isRequired,
        handleExpand: PropTypes.func.isRequired,
        handleExpanded: PropTypes.func.isRequired,
        lang: PropTypes.object.isRequired,
        setAllDay: PropTypes.func.isRequired,
        toggleFilter: PropTypes.func.isRequired
    }

    checkIsExpanded = () => {
        const {
            expandedGroups,
            filterGroupCollectionIndex
        } = this.props;
        return expandedGroups.filter(
            i => Number(i.index) === Number(filterGroupCollectionIndex)
        ).length;
    }

    getClassId = () => {
        const {
            expandedGroups,
            filterGroupCollectionIndex
        } = this.props;
        return expandedGroups.filter(i => i.index === filterGroupCollectionIndex).length ?
            expandedGroups.find(i => i.index === filterGroupCollectionIndex).classId : 0;
    }

    handleFilterChange = event => {
        const { updateFilterGroupCollection } = this;
        const { filterGroupCollection, setAllDay } = this.props;
        const filterIndex = event.target.dataset.filterIndex;
        const filterGroupIndex = event.target.dataset.filterGroupIndex;
        const inputType = event.target.dataset.inputType;
        let value;
        if (inputType === 'checkbox') {
            value = event.target.checked;
        } else if (inputType === 'radio') {
            value = event.target.checked;
        } else if (inputType === 'increment') {
            value = Number(event.target.dataset.value);
        } else if (inputType === 'dropdown') {
            value = event.target.value;
        } else if (inputType === 'toggle-switch') {
            value = event.target.checked;
            if (filterGroupCollection.filterGroups[filterGroupIndex].slug === 'all-day') {
                setAllDay();
            }
        } else if (inputType === 'dropdown') {
            value = Number(event.target.value);
        } else {
            value = event.target.value;
        }
        const updatedFilter = {
            ...filterGroupCollection.filterGroups[filterGroupIndex].filters[filterIndex],
            data: {
                ...filterGroupCollection.filterGroups[filterGroupIndex].filters[filterIndex].data,
                value
            }
        };
        updateFilterGroupCollection(filterGroupIndex, filterIndex, updatedFilter);
    }

    handleSliderChange = (filterGroupIndex, filterIndex, valueArr) => {
        const { updateFilterGroupCollection } = this;
        const { filterGroupCollection } = this.props;
        const updatedValues = [
            {
                slug: 'max_price',
                value: Number(valueArr[1])
            },
            {
                slug: 'min_price',
                value: Number(valueArr[0])
            }
        ];
        const updatedFilter = {
            ...filterGroupCollection.filterGroups[filterGroupIndex].filters[filterIndex],
            data: {
                ...filterGroupCollection.filterGroups[filterGroupIndex].filters[filterIndex].data,
                values: updatedValues
            }
        };
        updateFilterGroupCollection(filterGroupIndex, filterIndex, updatedFilter);
    }

    renderFilter = (filter, filterIndex, filterGroup, filterGroupIndex) => {
        const {
            handleFilterChange,
            handleSliderChange
        } = this;
        const {
            allDay,
            filterGroupCollectionIndex,
            lang
        } = this.props;
        return (
            <Filter
                key={shortid.generate()}
                columns={filterGroup.columns}
                filter={filter}
                filterIndex={filterIndex}
                filterGroup={filterGroup}
                filterGroupCollectionIndex={filterGroupCollectionIndex}
                filterGroupIndex={filterGroupIndex}
                handleFilterChange={handleFilterChange}
                handleSliderChange={handleSliderChange}
                isDisabled={
                    ((filterGroup.slug === 'duration' ||
                    filterGroup.slug === 'time') && allDay) ?
                        true : false
                }
                lang={lang}
                noContainer
            />
        );
    }

    renderCollapsedFilter = (filter, filterIndex, filterGroup, filterGroupIndex) => {
        const {
            handleFilterChange,
            handleSliderChange
        } = this;
        const {
            allDay,
            filterGroupCollectionIndex,
            lang
        } = this.props;
        return (
            <div
                key={shortid.generate()}
                className="row"
            >
                <Filter
                    columns={filterGroup.columns}
                    filter={filter}
                    filterIndex={filterIndex}
                    filterGroup={filterGroup}
                    filterGroupIndex={filterGroupIndex}
                    filterGroupCollectionIndex={filterGroupCollectionIndex}
                    handleFilterChange={handleFilterChange}
                    handleSliderChange={handleSliderChange}
                    isDisabled={
                        ((filterGroup.slug === 'duration' ||
                        filterGroup.slug === 'time') && allDay) ?
                            true : false
                    }
                    lang={lang}
                />
            </div>
        );
    }

    renderExtraFiltersCollapse = (filterGroup, filterGroupIndex) => {
        const {
            checkIsExpanded,
            renderFilter
        } = this;
        const {
            expandedGroups,
            filterGroupCollection,
            filterGroupCollectionIndex,
            handleExpand,
            handleExpanded
        } = this.props;
        const { buttonText, defaultButtonText } = filterGroupCollection;
        const isExpanded = checkIsExpanded();
        return (
            <ExtraFiltersCollapse
                key={shortid.generate()}
                classId={
                    expandedGroups.filter(i => i.index === filterGroupCollectionIndex).length ?
                        expandedGroups.find(i => i.index === filterGroupCollectionIndex).classId : 0
                }
                collapseText={filterGroup.collapseText}
                expandedGroups={expandedGroups}
                expandText={filterGroup.expandText}
                filterGroupIndex={filterGroupCollectionIndex}
                handleExpand={handleExpand}
                handleExpanded={handleExpanded}
                isExpanded={isExpanded}
                extraFilters={
                    filterGroup.filters.map((filter, index) =>
                        renderFilter(filter, index, filterGroup, filterGroupIndex))
                }
                isSmallScreenPanel
                title={defaultButtonText ? defaultButtonText : buttonText}
            />
        );
    }

    updateFilterGroupCollection = (filterGroupIndex, filterIndex, updatedFilter) => {
        const { filterGroupCollection, toggleFilter } = this.props;
        const filters = filterGroupCollection.filterGroups[filterGroupIndex]
            .filters.map((filter, index) => {
                if (Number(index) !== Number(filterIndex)) {
                    return filter;
                }
                return {
                    ...filter,
                    ...updatedFilter
                };
            });
        const filterGroups = filterGroupCollection.filterGroups.map((filterGroup, index) => {
            if (Number(index) !== Number(filterGroupIndex)) {
                return filterGroup;
            }
            return {
                ...filterGroup,
                filters
            };
        });
        const updatedFilterGroupCollection = {
            ...filterGroupCollection,
            filterGroups
        };
        toggleFilter(updatedFilterGroupCollection);
    };

    render() {
        const {
            checkIsExpanded,
            getClassId,
            renderCollapsedFilter,
            renderExtraFiltersCollapse
        } = this;
        const {
            activeFilterGroupCollectionIndex,
            filterGroupCollection,
            filterGroupCollectionIndex,
            handleExpand,
            handleExpanded
        } = this.props;
        const { filterGroups, buttonText, defaultButtonText } = filterGroupCollection;
        const isExpanded = checkIsExpanded();
        const classId = getClassId();
        return (
            <div className={css(styles.container, styles.baseline)}>
                <div>
                    <div className={css(styles.containerFallback)}>
                        <div className={css(styles.beforeFallback)}>
                            <span className={css(styles.text, styles.size_regular, styles.weight_light)}>
                                <span
                                    dangerouslySetInnerHTML={defaultButtonText ? { __html: defaultButtonText } : { __html: buttonText }}
                                />
                            </span>
                        </div>
                        {
                            (filterGroupCollectionIndex > 1) ?
                                <div className={css(styles.afterFallback)}>
                                    <span className={css(styles.textInline)}>
                                        <CaretWrapper
                                            classId={classId}
                                            filterGroupCollectionIndex={filterGroupCollectionIndex}
                                            isExpanded={isExpanded}
                                            handleExpand={handleExpand}
                                            handleExpanded={handleExpanded}
                                            title={defaultButtonText ? defaultButtonText : buttonText}
                                        />
                                    </span>
                                </div> : null
                        }
                    </div>
                </div>
                <div
                    className={
                        Number(activeFilterGroupCollectionIndex) === Number(filterGroupCollectionIndex) || filterGroupCollectionIndex <= 1 ?
                            css(styles.collapsedTitleContainer) : ''
                    }
                >
                    {
                        filterGroupCollectionIndex > 1 ?
                            filterGroups.map(renderExtraFiltersCollapse) :
                            filterGroups.map((filterGroup, filterGroupIndex) => {
                                return filterGroup.filters.map((filter, index) =>
                                    renderCollapsedFilter(filter, index, filterGroup, filterGroupIndex)
                                );
                            })
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    activeFilterGroupCollectionIndex: state.activeFilterGroupCollectionIndex,
    lang: state.lang
});

export default connect(mapStateToProps)(PanelFilterGroupCollection);



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/PanelFilterGroupCollection/PanelFilterGroupCollection.jsx